// @dirty full rewrite
import { mauve } from '@radix-ui/colors'
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import { keyframes } from '@stitches/react'
import { config, styled } from '@themes/stitches.config'

export const Root = styled(DropdownMenu.Root, {})

export const Trigger = styled(DropdownMenu.Trigger, {})

export const Portal = styled(DropdownMenu.Portal, {})

export const Sub = styled(DropdownMenu.Sub, {})

export const RadioGroup = styled(DropdownMenu.RadioGroup, {})

const slideUpAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateY(2px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideRightAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateX(-2px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
})

const slideDownAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateY(-2px)' },
  '100%': { opacity: 1, transform: 'translateY(0)' },
})

const slideLeftAndFade = keyframes({
  '0%': { opacity: 0, transform: 'translateX(2px)' },
  '100%': { opacity: 1, transform: 'translateX(0)' },
})

const contentStyles = {
  minWidth: 220,
  overflow: 'hidden',
  backgroundColor: config.theme.colors.slateA1,
  backdropFilter: 'blur(40px)',
  borderRadius: 8,
  boxShadow:
    '0px 10px 38px -10px rgba(22, 23, 24, 0.35), 0px 10px 20px -15px rgba(22, 23, 24, 0.2)',

  animationDuration: '400ms',
  animationTimingFunction: 'cubic-bezier(0.16, 1, 0.3, 1)',
  willChange: 'transform, opacity',
  '&[data-state="open"]': {
    '&[data-side="top"]': { animationName: slideDownAndFade },
    '&[data-side="right"]': { animationName: slideLeftAndFade },
    '&[data-side="bottom"]': { animationName: slideUpAndFade },
    '&[data-side="left"]': { animationName: slideRightAndFade },
  },
}

export const Content = styled(DropdownMenu.Content, contentStyles)

export const SubContent = styled(DropdownMenu.SubContent, contentStyles)

export const Arrow = styled(DropdownMenu.Arrow, {
  fill: 'white',
  borderColor: 'red',
})

const itemStyles = {
  all: 'unset',
  fontSize: 17,
  fontFamily: config.theme.fonts.regular,
  lineHeight: '22px',
  color: config.theme.colors.slate11,

  cursor: 'pointer',

  boxSizing: 'border-box',
  display: 'flex',
  alignItems: 'center',
  // height: 44,

  paddingTop: 16,
  paddingBottom: 16,
  paddingLeft: 16,
  paddingRight: 18,
  position: 'relative',

  userSelect: 'none',
  overflow: 'hidden',

  '&[data-disabled]': {
    color: config.theme.colors.slate8,
    pointerEvents: 'none',
  },

  '&[data-highlighted]': {
    backgroundColor: config.theme.colors.slateA2,
    // color: config.theme.colors.slate1,
  },
}

const statefulItemStyles = {
  ...itemStyles,
  paddingLeft: 33,
}

export const MenuItem = styled(DropdownMenu.Item, itemStyles)

export const CheckboxItem = styled(
  DropdownMenu.CheckboxItem,
  statefulItemStyles
)

export const RadioItem = styled(DropdownMenu.RadioItem, statefulItemStyles)

export const SubTrigger = styled(DropdownMenu.SubTrigger, {
  '&[data-state="open"]': {
    backgroundColor: config.theme.colors.slateA4,
    color: config.theme.colors.slate11,
  },
  ...itemStyles,
})

export const Label = styled(DropdownMenu.Label, {
  fontFamily: config.theme.fonts.regular,
  textTransform: 'uppercase',
  paddingLeft: 16,
  paddingTop: 8,
  letterSpacing: 0.5,
  fontSize: 11,
  lineHeight: '25px',
  color: config.theme.colors.slate11,
})

export const SectionSeparator = styled(DropdownMenu.Separator, {
  height: 8,
  backgroundColor: config.theme.colors.slateA5,

  margin: 0,
})

export const RowSeparator = styled(DropdownMenu.Separator, {
  height: 1,
  backgroundColor: config.theme.colors.slateA4,

  margin: 0,
})

export const ItemIndicator = styled(DropdownMenu.ItemIndicator, {
  position: 'absolute',
  left: 6,
  width: 25,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export const RightSlot = styled('div', {
  marginLeft: 'auto',
  paddingLeft: 19,
  color: config.theme.colors.slate8,
  // '[data-highlighted] > &': { color: config.theme.colors.slate7 },
  '[data-disabled] &': { color: mauve.mauve8 },
})

export const IconButton = styled('button', {
  all: 'unset',
  fontFamily: 'inherit',
  borderRadius: '100%',
  height: 32,
  width: 32,
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  boxSizing: 'border-box',
  color: config.theme.colors.slate11,
  backgroundColor: config.theme.colors.white,
  // boxShadow: `0 2px 10px ${blackA.blackA7}`,
  cursor: 'pointer',
  '&:hover': { backgroundColor: config.theme.colors.slate3 },
  '&:focus': { boxShadow: `0 0 0 2px var(--colors-sky5)` },
})
